/* tslint:disable */
export interface ProductContractResponse {}
/* tslint:enable */
